/**
 * A global namespace for 'animationend' string.
 */
const animationEndEvent = 'animationend';
export default animationEndEvent;
